export default "__VITE_ASSET__D0BMpMz5__"